// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"27f53792","455":"2012439d","488":"c9177343","977":"148011bd"}[chunkId] + ".chunk.js";
};